import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import useAuth from '../useAuth';
import AttendanceCard from '../../components/AttendanceCards';


// 🔸 Status Summary Card Block
const CardBlock = ({ title, data, bg }) => (
     <div
          style={{
               backgroundColor: bg,
               borderRadius: '10px',
               padding: '16px 20px',
               minWidth: '220px',
               flex: '1 1 220px',
               boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
          }}
     >
          <h5 style={{ fontSize: '16px', marginBottom: '12px', color: '#333' }}>{title}</h5>
          <div>
               {Object.entries(data).map(([key, value]) => (
                    <div key={key} style={{ marginBottom: '6px', fontSize: '14px', color: '#555' }}>
                         <strong>{key}:</strong> {value}
                    </div>
               ))}
          </div>
     </div>
);

// 🔸 Attendance Records Table
const AttendanceDetailsTable = ({ records }) => (
     <Card style={{ marginTop: '32px' }}>
          <Card.Body>
               <h5>Attendance Details</h5>
               <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%' }} className="table table-striped table-bordered mt-3">
                         <thead>
                              <tr>
                                   <th>Date</th>
                                   <th>Punch In</th>
                                   <th>Punch Out</th>
                                   <th>Status</th>
                              </tr>
                         </thead>
                         <tbody>
                              {records.length === 0 ? (
                                   <tr>
                                        <td colSpan="4" style={{ textAlign: 'center' }}>No records found.</td>
                                   </tr>
                              ) : (
                                   records.map((record, index) => (
                                        <tr key={index}>
                                             <td>{record.date}</td>
                                             <td>{record.punch_in || '-'}</td>
                                             <td>{record.punch_out || '-'}</td>
                                             <td>{record.status}</td>
                                        </tr>
                                   ))
                              )}
                         </tbody>
                    </table>
               </div>
          </Card.Body>
     </Card>
);

// 🔸 Main UserRadiology_Dashboard Component
const UserRadiology_Dashboard = () => {
     //  useAuth();
     const baseUrl = process.env.REACT_APP_BASE_URL;

     // determine role flags (do NOT return here — hooks must run first)
     const user_role = sessionStorage.getItem('user_role');
     const is_radiology_doctor = sessionStorage.getItem('is_radiology_doctor');


     const [attendanceData, setAttendanceData] = useState(null);
     const [loading, setLoading] = useState(true);
     const [statusCounts, setStatusCounts] = useState(null);
     const [currentEmployee, setCurrentEmployee] = useState({
          photo: 'https://randomuser.me/api/portraits/men/32.jpg',
          name: '',
          id: '',
          role: ''
     });

     const [showPopup, setShowPopup] = useState(false);
     const popupRef = useRef(null);
     const buttonRef = useRef(null);

     useEffect(() => {
          const userCode = sessionStorage.getItem('user_code');
          const userName = sessionStorage.getItem('user_name');
          const userRole = sessionStorage.getItem('user_role');
          setCurrentEmployee((prev) => ({
               ...prev,
               name: userName,
               id: userCode,
               role: userRole || 'User'
          }));
     }, []);

     useEffect(() => {
          const fetchAttendance = async () => {
               try {
                    setLoading(true);
                    const response = await fetch(`${baseUrl}/getUserAttendance`, {
                         method: "GET",
                         headers: {
                              "Content-Type": "application/json",
                              "Authorization": `Bearer ${sessionStorage.getItem("token")}`
                         },
                    });

                    const data = await response.json();
                    if (data.status) {
                         setAttendanceData(data.data);
                    }
               } catch (error) {
                    console.error("Error fetching attendance:", error);
               } finally {
                    setLoading(false);
               }
          };

          fetchAttendance();
     }, [baseUrl]);

     useEffect(() => {
          const fetchStatusCounts = async () => {
               try {
                    const response = await fetch(`${baseUrl}/getStatus`, {
                         method: 'GET',
                         headers: {
                              'Content-Type': 'application/json',
                              Authorization: `Bearer ${sessionStorage.getItem('token')}`
                         }
                    });

                    const result = await response.json();
                    if (result.status) {
                         setStatusCounts(result.data);
                    }
               } catch (error) {
                    console.error("Error fetching status counts:", error);
               }
          };

          fetchStatusCounts();
     }, [baseUrl]);

     useEffect(() => {
          const handleClickOutside = (event) => {
               if (
                    popupRef.current &&
                    !popupRef.current.contains(event.target) &&
                    buttonRef.current &&
                    !buttonRef.current.contains(event.target)
               ) {
                    setShowPopup(false);
               }
          };

          document.addEventListener('mousedown', handleClickOutside);
          return () => {
               document.removeEventListener('mousedown', handleClickOutside);
          };
     }, []);


     const todayPunchIn = attendanceData?.today?.punch_in || "-";
     const todayPunchOut = attendanceData?.today?.punch_out || "-";
     const weekPresent = attendanceData?.this_week?.present_days ?? 0;
     const weekAbsent = attendanceData?.this_week?.absent_days ?? 0;
     const monthPresent = attendanceData?.this_month?.present_days ?? 0;
     const monthAbsent = attendanceData?.this_month?.absent_days ?? 0;
     const attendanceRecords = attendanceData?.records || [];

     return (
          <>


               <div
                    style={{
                         padding: '24px',
                         backgroundColor: '#f7f9fc',
                         minHeight: '100vh',
                    }}
               >
                    <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                         {/* Status Cards */}
                         {(is_radiology_doctor === "Y") && statusCounts && (
                              <div
                                   style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: '16px',
                                        marginBottom: '24px',
                                   }}
                              >


                                   <CardBlock
                                        title="Manager Status - My"
                                        data={statusCounts.rpt_mgr_status_counts_user}
                                        bg="#e8f0fe"
                                   />
                                   <CardBlock
                                        title="HR Status - My"
                                        data={statusCounts.hr_status_counts_user}
                                        bg="#fdecea"
                                   />
                              </div>
                         )}



                         {/* Attendance Summary Cards */}
                         {(is_radiology_doctor === "N" || user_role === 'SUPER_ADMIN') && (
                              <Row style={{ marginBottom: '24px' }}>

                                   <Col md={9}>
                                        <div
                                             style={{
                                                  display: 'grid',
                                                  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                                                  gap: '16px',
                                             }}
                                        >
                                             <AttendanceCard
                                                  title="Today's Attendance"
                                                  present={todayPunchIn}
                                                  absent={todayPunchOut}
                                             />

                                        </div>
                                   </Col>
                              </Row>)}

                         {/* Attendance Table */}
                         {/* <AttendanceDetailsTable records={attendanceRecords} /> */}
                    </div>
               </div>
          </>
     );
};

export default UserRadiology_Dashboard;
